import React, { useContext, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Alert,
  Form,
  Spinner,
} from "react-bootstrap";
import ContextApp from "../../../core/contexts/context.app";

import {
  IconMinus,
  IconPlus,
  IconDelete,
  IconEmptyBasket,
  IconGift,
  IconErrorCircle,
  IconEdit,
} from "../../../assets/icons";
import SplitNumber from "../../components/SplitNumber";
import Swal from "sweetalert2";
import { Zoom } from "react-awesome-reveal";
import { isMobile } from "react-device-detect";
import { BasketHelper } from "../../../core/utils/BasketHelper";
import _ from "lodash";
import { Link } from "react-router-dom";
import LoaderDot from "../../components/LoaderDot";
import ModalSelectName from "./Component/ModalSelectName";
import { useForm, Controller } from "react-hook-form";
import ServiceStorage from "../../../core/services/service.storage";
import { ToastContainer, toast } from "react-toastify";
import CounterButton from "./Component/CounterButton";

function BasketContent() {
  const ctx = useContext(ContextApp);
  const [basketItemsList, setBasketItemsList] = useState();
  const [basket, setBasket] = useState();
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState(data);
  const [loaderDot, setLoaderDot] = useState(false);
  const [specialDiscount, setSpecialDiscount] = useState(false);
  const [modalSelectNameInfo, setModalSelectNameInfo] = useState({
    show: false,
    basketPersonPersonFullName: "",
  });
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({ defaultValues: { id: 0 } });
  const [promoCodeIsSuccess, setPromoCodeIsSuccess] = useState();
  const [selectedItemId, setSelectedItemId] = useState(null);
  useEffect(() => {
    (async () => {
      if (ctx.isAuth) {
        try {
          if (ctx.isAuth) {
            // اول لیست افراد وابسطه به این کاربر اپدیت بشه
            const basketPersonList = BasketHelper.getBasketPersonList(ctx);
            //ادغام و دریافت اخرین سبد خرید فعال
            const basket5 = BasketHelper.getBasket(ctx);
          }
        } catch (error) {}
      }
      // let basketTemp = await BasketHelper.getBasketFromStorage(ctx);
      // if (!_.isEmpty(basketTemp)) {
      //   setBasket(basketTemp);
      // }
    })();
  }, []);
  useEffect(() => {
    if (!_.isEmpty(ctx.basketInfo) && !_.isEmpty(ctx.basketInfo.promoCode)) {
      setValue("promoCode", ctx.basketInfo.promoCode);
      setPromoCodeIsSuccess(true);
    }
  }, []);
  useEffect(() => {
    (async () => {
      let basketTemp = await BasketHelper.getBasketFromStorage(ctx);
      if (!_.isEmpty(basketTemp)) {
        setBasket(basketTemp);
      }
    })();
  }, [ctx.basketInfo]);

  const getBasketITemDetailForDisplay = function (details) {
    let showDetails = "";
    if (!_.isEmpty(details)) {
      JSON.parse(details)?.map((item, index) => {
        if (_.isEmpty(showDetails)) showDetails += item.text;
        else showDetails += " - <span class='fw-bold'>" + item.text + "</span>";
      });
    }
    return showDetails;
  };

  const sweetAlertModal = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-outline-success mt-2",
    },
    buttonsStyling: false,
  });
  // دگمه افزایش تعداد بلیط
  const increment = (item) => {
    if (item.totalCount < 30) changeBasket(item, item.totalCount + 1);
  };
  const decrement = (item) => {
    if (item.totalCount > 0) changeBasket(item, item.totalCount - 1);
  };
  async function changeBasket(item, basketItemCount) {
    try {
      if (!loaderDot) {
        setLoaderDot(true);
      }
      await BasketHelper.changeBasketItemTotalCount(ctx, item, basketItemCount);
      setLoaderDot(false);
    } catch (error) {
      setLoaderDot(false);
    }
  }
  // دگمه کاهش تعداد بلیط

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const showModalSelectName = (basketPersonPerson) => {
    setModalSelectNameInfo({
      show: true,
      basketPersonPerson: basketPersonPerson,
    });
  };

  const updateSelectedName = (name) => {
    // const updatedBasket = { ...basket };
    // const itemIndex = updatedBasket.basketItemTemps.findIndex(
    //   (item) => item.id === selectedItemId
    // );
    // if (itemIndex > -1) {
    //   updatedBasket.basketItemTemps[
    //     itemIndex
    //   ].basketItemPersonTemps[0].basketPersonPersonFullName = name;
    //   setBasket(updatedBasket);
    //   setModalSelectNameShow(false);
    // }
  };
  const onSubmitPromoCode = async (data) => {
    //اعمال کد توسط کاربر
    // پرمو کد داخل

    if (
      data.promoCode != null &&
      ServiceStorage.getPromoCode() != data.promoCode
    ) {
      ServiceStorage.removePromoCode();
    }
    //
    let newBasket = await BasketHelper.addPromoCodeToBasket(
      ctx,
      data.promoCode
    );

    const discountPrice = newBasket.salePrice - newBasket.price;

    if (_.isEmpty(newBasket.promoCode)) {
      setPromoCodeIsSuccess(false);
      toast.error(" کد تخفیف نامعتبر مجددا امتحان کنید", {
        duration: 10000,
        position: "bottom-center",
        theme: "colored",
      });
    } else {
      setPromoCodeIsSuccess(true);
      const sweetAlertModal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-outline-success mt-2",
        },
        buttonsStyling: false,
      });
      sweetAlertModal.fire({
        icon: "success",
        title: " کد تخفیف با موفقیت اعمال شد ",
        type: "success",
        html:
          "<div class='text-center fs-085'>" +
          "مبلغ" +
          "<span class='fw-bold px-1'> " +
          Number(discountPrice).toLocaleString() +
          " تومان " +
          " </span>" +
          "<span> مازاد بر تخفیفات قبل از سبد خرید شما کسر گردید</span>" +
          "<div>",
        // title:"<p>کد تخفیف با موفقیت اعمال شد .</p>",
        confirmButtonText: "تایید",
      });
    }
  };

  return (
    <>
      {modalSelectNameInfo && (
        <ModalSelectName
          modalSelectNameInfo={modalSelectNameInfo}
          setModalSelectNameInfo={setModalSelectNameInfo}
        />
      )}
      <ToastContainer position="top-center" rtl="true" />
      {isMobile ? (
        <>
          {/*********** حالت موبایل ****************** */}
          {_.filter(basket?.basketItemTemps, { isDeleted: false })?.length ===
          0 ? (
            <Container className="basket-items margin-bottom-basket-page pt-2 px-1">
              {/*********** اگر سبد خالی است *******************/}
              <div className="full-width mx-4 text-center">
                <IconEmptyBasket />
                <div className="fs-103 mt-5 fw-bold">
                  سبد خرید شما خالی است !
                </div>
                <div className="mt-3 fs-101 text-black-06">
                  برای مشاهده لیست تفریحات از لینک زیر استفاده کنید.
                </div>
                <Link
                  to={
                    ctx.selectedCity?.englishName === undefined
                      ? "/c"
                      : `/c/${ctx.selectedCity?.englishName}`
                  }
                  className="mt-3 btn btn-primary px-4"
                >
                  لیست تفریحات
                </Link>
              </div>
            </Container>
          ) : (
            <Container className="basket-items margin-bottom-basket-page bg-light-3 pt-2 px-1 ">
              <Card className="mb-2 rounded-3">
                <Card.Body className="p-1">
                  {_.filter(basket?.basketItemTemps, { isDeleted: false })?.map(
                    (item) => (
                      <div
                        key={item.id}
                        className="px-1 pt-1 mb-1 pb-3 gx-0 border-bottom"
                      >
                        <Row>
                          <Col xs="auto" className="pe-0">
                            <img
                              src={
                                process.env.REACT_APP_API_URL +
                                item.amusementServiceImageUrl +
                                "?width=120"
                              }
                              alt={item.amusementServiceName}
                              className="rounded-2"
                              style={{ width: "120px" }}
                            />
                          </Col>
                          <Col className="">
                            <div className="fw-bold  text-truncate-1-line">
                              {item.amusementServiceName}
                            </div>

                            <div
                              className="text-truncate-1-line fs-062 mt-1"
                              dangerouslySetInnerHTML={{
                                __html: getBasketITemDetailForDisplay(
                                  item.details
                                ),
                              }}
                            ></div>
                            <div className="fs-07 mt-2">
                              <span className="text-black-06"> تاریخ : </span>
                              <span className="ms-1 fw-bold">
                                {item.checkInDate}
                              </span>
                            </div>

                            {false &&
                              ctx.isAuth &&
                              !_.isEmpty(
                                _.trim(
                                  item?.basketItemPersonTemps[0]
                                    ?.basketPersonPersonFullName
                                )
                              ) && (
                                <div className="fs-07 d-flex align-items-center mt-2">
                                  <span className="text-black-06  white-space-nowrap">
                                    نام :{" "}
                                  </span>
                                  <span className="ms-1 fw-bold text-truncate-1-line">
                                    {
                                      item?.basketItemPersonTemps[0]
                                        ?.basketPersonPersonFullName
                                    }{" "}
                                  </span>
                                  <span className=" ms-1">
                                    <div
                                      className="d-inline-block small-svg px-1"
                                      onClick={showModalSelectName(
                                        item?.basketItemPersonTemps[0]
                                      )}
                                    >
                                      <IconEdit fillColor="#0ca473" />
                                    </div>
                                  </span>
                                </div>
                              )}
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs="auto">
                            <div>
                              <Col xs="12" className=" px-0 mx-0 d-flex  ">
                                <CounterButton
                                  totalCount={item.totalCount}
                                  item={item}
                                />
                              </Col>
                            </div>
                          </Col>
                          <Col className="my-auto ps-0">
                            {item.sumOriginalPrice - item.sumPrice > 0 && (
                              <div className="fs-065 text-danger mb-1 small-svg">
                                <IconGift fillColor="#f80248" />
                                <SplitNumber
                                  number={item.sumOriginalPrice - item.sumPrice}
                                ></SplitNumber>
                                <span className=""> تخفیف</span>
                              </div>
                            )}
                            <div className="">
                              <span className="fw-bold text-black fs-normal ">
                                <SplitNumber
                                  number={item.sumPrice}
                                ></SplitNumber>
                              </span>
                              <span className="fs-085  ms-1">تومان</span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )
                  )}
                </Card.Body>
              </Card>
              {/********** اگر سبد آیتم  دارد ******************/}
              <Card className="mt-3 rounded-3 mb-3">
                <Card.Header className="fw-bold border-bottom-0 py-3 bg-white">
                  خلاصه سبد خرید
                </Card.Header>
                <Card.Body className="pt-0">
                  <div className="border-top pt-3 pb-4">
                    {basket.originalPrice !== basket.price && (
                      <div class="d-flex align-items-center">
                        <div
                          class="col-5 text-dark rounded text-center fs-075 mb-1 col"
                          style={{
                            backgroundColor: "rgb(189, 190, 192)",
                            paddingTop: "9px",
                            paddingBottom: "10px",
                          }}
                        >
                          قیمت
                        </div>
                        <div
                          class="col-7 text-dark rounded  text-center py-2 ms-1 mb-1 fs-085 col"
                          style={{
                            backgroundColor: "rgb(233, 236, 239)",
                          }}
                        >
                          <span className="text-decoration-line-throught-rotate border-secondary text-black-06">
                            <SplitNumber number={basket?.originalPrice} />
                          </span>
                          <span className="fs-075 ms-1">تومان</span>
                        </div>
                      </div>
                    )}

                    {basket.originalPrice !== basket.price && (
                      <div class="d-flex align-items-center">
                        <div
                          class="col-5 rounded text-dark  fs-075 text-center text-center  mb-1 col"
                          style={{
                            backgroundColor: "rgb(255, 227, 143)",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                          }}
                        >
                          تخفیف
                        </div>
                        <div
                          class="col-7 rounded text-dark text-center py-2 ms-1 mb-1 fs-085 col"
                          style={{
                            backgroundColor: "rgb(255, 247, 224)",
                          }}
                        >
                          <SplitNumber
                            number={basket?.originalPrice - basket?.salePrice}
                          />
                          <span className="fs-075 ms-1">تومان</span>
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(ctx.basketInfo.promoCode) && (
                      <div class="d-flex align-items-center">
                        <div
                          class="col-5 rounded text-dark  fs-075 text-center text-center  mb-1 col"
                          style={{
                            backgroundColor: "#ffc107",
                            paddingTop: "9px",
                            paddingBottom: "10px",
                          }}
                        >
                          تخفیف ویژه
                        </div>

                        <div
                          class="col-7 rounded text-dark text-center py-2 ms-1 mb-1 fs-085 col"
                          style={{
                            backgroundColor: "#ffedb8",
                          }}
                        >
                          <SplitNumber
                            number={
                              ctx.basketInfo.salePrice - ctx.basketInfo.price
                            }
                          />
                          <span className="fs-075 ms-1">تومان</span>
                        </div>
                      </div>
                    )}
                    <div class="d-flex align-items-center fs-normal">
                      <div
                        class="fw-bold rounded  text-white col-5  fs-075 text-center   col"
                        style={{
                          backgroundColor: "rgb(12, 164, 115)",
                          paddingTop: "9px",
                          paddingBottom: "10px",
                        }}
                      >
                        قیمت نهایی
                      </div>
                      <div
                        class="fw-bold rounded text-dark text-center col-7 py-2 ms-1  col"
                        style={{
                          backgroundColor: "rgb(193, 231, 219)",
                        }}
                      >
                        <span className="fs-085">
                          <SplitNumber number={basket?.price} />
                        </span>
                        <span className="fs-075 ms-1">تومان</span>
                      </div>
                    </div>
                  </div>

                  <form id="form" onSubmit={handleSubmit(onSubmitPromoCode)}>
                    {specialDiscount && promoCodeIsSuccess && (
                      <div>
                        {/* <Form.Label className='large mx-2 my-2'>کد تخفیف</Form.Label> */}
                        {/* <hr className="p-0 my-0" /> */}
                        {/* <hr className="p-0 py-0 my-0" /> */}

                        {/* <FactorListItem
                FactorItemTitle="تخفیف ویژه"
                FactorItemCount={ctx.basketInfo.salePrice - ctx.basketInfo.price + " تومان"}
                bgcolor1="#ffc107"
                bgcolor2="#ffedb8"
               
                styleNameClass1="col-5 rounded text-dark mb-1  text-center "
                styleNameClass2="col-7 rounded text-dark text-center mb-1 py-2 mr-1 "
                isLine={false}
              />
           
              <FactorListItem
                FactorItemTitle="قیمت نهایی"
                FactorItemCount={ctx.basketInfo.price + " تومان"}
                bgcolor1="#0ca473"
                bgcolor2="#c1e7db"
                styleNameClass1="font-weight-bold rounded  text-white col-5  text-center  "
                styleNameClass2="font-weight-bold rounded text-dark text-center col-7 py-2 mr-1 "
                isLine={false}
              /> */}
                      </div>
                    )}

                    <div className="d-flex">
                      <Controller
                        control={control}
                        {...register("promoCode")}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <Form.Control
                            autoFocus={false}
                            placeholder="کدتخفیف"
                            name="promoCode"
                            className="text-center text-dark rounded-end-0 font-latin"
                            style={
                              errors.promoCode
                                ? {
                                    letterSpacing: "0px",
                                    borderColor: "red",
                                    height: "37px",
                                  }
                                : value
                                ? {
                                    letterSpacing: "5px",
                                    height: "37px",
                                  }
                                : { height: "37px" }
                            }
                            maxLength="5"
                            autoComplete="off"
                            value={value || ""}
                            onChange={onChange}
                          />
                        )}
                      />
                      <div className="d-flex align-items-center">
                        {/* <button
                        disabled
                        type="submit"
                        className="btn btn-primary mt-2 px-4"
                      >
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="state"
                          aria-hidden="true"
                        ></span>
                        ارسال کد
                      </button> */}
                        <Button
                          type="submit"
                          variant="warning"
                          className="text-center text-white fs-085 border-0 px-1"
                          style={{
                            width: "83px",
                            height: "37px",
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                            backgroundColor: "#ff6400",
                          }}
                          autoComplete="off"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <>
                              اعمال کد
                              <span
                                className="spinner-border spinner-border-sm ms-1"
                                role="state"
                                aria-hidden="true"
                              ></span>
                            </>
                          ) : (
                            "اعمال کد"
                          )}
                        </Button>
                      </div>
                    </div>
                    {promoCodeIsSuccess ? (
                      <div className=" text-success font-weight-bold mt-2 mb-2">
                        {" "}
                        کد تخفیف با موفقیت اعمال گردید
                      </div>
                    ) : promoCodeIsSuccess == undefined ? (
                      ""
                    ) : (
                      <div>
                        <div className=" text-danger  mt-2 mb-2">
                          {" "}
                          کد تخفیف نامعتبر{" "}
                        </div>
                        {/* <ToastContainer
                          position="bottom-center"
                          autoClose={5000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={true}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                        /> */}
                      </div>
                    )}
                  </form>
                </Card.Body>
              </Card>
              <div className="pb-2">
                <Alert variant="secondary" className="">
                  <IconErrorCircle fillColor="#000" />
                  تفریحات موجود در سبد شما ثبت و رزرو نشده اند، برای ثبت سفارش
                  بر روی دکمه <span className="fw-bold">
                    ادامه فرآیند خرید
                  </span>{" "}
                  کلیک نمایید.
                </Alert>
              </div>
              <div
                className="d-flex justify-content-between align-items-center  w-100 bg-white px-3 py-2 position-fixed "
                style={{
                  bottom: "56px",
                  zIndex: "1045",
                  borderTop: "1px solid #939393",
                }}
              >
                <div className="fs-075 fw-normal">
                  <div>
                    <span className=" fs-09">
                      {
                        _.filter(basket?.basketItemTemps, { isDeleted: false })
                          ?.length
                      }
                    </span>{" "}
                    سفارش
                  </div>
                  <div className="fw-bold fs-101">
                    <SplitNumber number={ctx?.basketInfo?.price} /> تومان
                  </div>
                </div>

                <div>
                  <Link className="btn btn-danger fs-09" to="/payment">
                    ادامه فرآیند خرید{" "}
                  </Link>
                </div>
              </div>
            </Container>
          )}
        </>
      ) : (
        /********** حالت دسکتاپ ******************/
        <Container fluid className="bg-light-3">
          <Container className="basket-items margin-bottom-basket-page pt-4 px-0">
            <Row>
              {/********** اگر سبد خالی است ******************/}
              {_.filter(basket?.basketItemTemps, { isDeleted: false })
                ?.length === 0 ? (
                <>
                  <div className="full-width text-center px-3 mb-5">
                    <IconEmptyBasket />
                  </div>
                  <Col className="pb-5 pt-3 text-center">
                    <div className="fs-103  fw-bold">
                      سبد خرید شما خالی است !
                    </div>
                    <div className="mt-3 fs-101 text-black-06">
                      برای مشاهده لیست تفریحات از لینک زیر استفاده کنید.
                    </div>
                    <Link
                      to={
                        ctx.selectedCity?.englishName === undefined
                          ? "/c"
                          : `/c/${ctx.selectedCity?.englishName}`
                      }
                      className="mt-3 btn btn-primary px-4"
                    >
                      لیست تفریحات
                    </Link>
                  </Col>
                </>
              ) : (
                <>
                  {/********** اگر سبد آیتم  دارد ******************/}

                  <Col md="8" xl="9" className="pe-0">
                    {_.filter(basket?.basketItemTemps, {
                      isDeleted: false,
                    })?.map((item) => (
                      <Card key={item.id} className="mb-3">
                        <Card.Body className="p-2">
                          <Row>
                            <Col md="auto" className="pe-0">
                              <img
                                src={
                                  process.env.REACT_APP_API_URL +
                                  item.amusementServiceImageUrl +
                                  "?width=170"
                                }
                                alt={item.amusementServiceName}
                                className=" rounded-2"
                                width="170px"
                              />
                            </Col>
                            <Col className="my-auto">
                              <div className="fw-bold pb-2">
                                {item.amusementServiceName}
                              </div>
                              <div className="fs-08 mt-2">
                                <span className="text-black-06"> تاریخ : </span>
                                <span className="ms-1 fw-bold ">
                                  {item.checkInDate}
                                </span>
                              </div>
                              <div
                                className="mt-2 fs-085"
                                dangerouslySetInnerHTML={{
                                  __html: getBasketITemDetailForDisplay(
                                    item.details
                                  ),
                                }}
                              ></div>
                              {false &&
                                ctx.isAuth &&
                                !_.isEmpty(
                                  _.trim(
                                    item?.basketItemPersonTemps[0]
                                      ?.basketPersonPersonFullName
                                  )
                                ) && (
                                  <div className="fs-085 mt-2 ">
                                    <span className="text-black-06">
                                      {" "}
                                      نام :
                                    </span>
                                    <span className="ms-1 fw-bold">
                                      {
                                        item?.basketItemPersonTemps[0]
                                          ?.basketPersonPersonFullName
                                      }{" "}
                                    </span>
                                    <span className=" ms-1">
                                      <div
                                        className="d-inline-block small-svg px-2 cursor-pointer"
                                        onClick={() =>
                                          showModalSelectName(
                                            item?.basketItemPersonTemps[0]
                                          )
                                        }
                                      >
                                        <IconEdit fillColor="#0ca473" />
                                      </div>
                                    </span>
                                  </div>
                                )}
                            </Col>
                            <Col
                              md="3"
                              xl="3"
                              className="text-center my-auto border-start  "
                            >
                              <div>
                                <Col
                                  xs="12"
                                  className=" px-0 mx-0 d-flex  justify-content-center mt-2"
                                >
                                  <CounterButton
                                    totalCount={item.totalCount}
                                    item={item}
                                  />
                                </Col>
                              </div>
                              {/* <div className="fw-bold fs-075 mt-2">تعداد بلیط </div> */}
                              <div className=" mt-2">
                                {item.sumOriginalPrice > item.sumPrice ? (
                                  <>
                                    <span className=" text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                                      <SplitNumber
                                        number={item.sumOriginalPrice}
                                      ></SplitNumber>
                                    </span>
                                    <span className="fs-075 text-black-06 ms-1">
                                      تومان
                                    </span>
                                  </>
                                ) : (
                                  <div className="mt-3"></div>
                                )}

                                {item.sumOriginalPrice - item.sumPrice > 0 && (
                                  <div className="fs-065 text-danger mb-1 small-svg">
                                    <IconGift fillColor="#f80248" />
                                    <SplitNumber
                                      number={
                                        item.sumOriginalPrice - item.sumPrice
                                      }
                                    ></SplitNumber>
                                    <span className=""> تخفیف</span>
                                  </div>
                                )}
                                {/*<span className="bg-success-light text-white d-inline-block fs-075 rounded-1 px-1 ms-1">
                                 {((item.sumOriginalPrice - item.sumPrice) /
                                item.sumOriginalPrice) *
                                100} % 
                              </span>*/}
                              </div>
                              <div className="mt-2">
                                <span className="fw-bold text-blck fs-101 ">
                                  <SplitNumber
                                    number={item.sumPrice}
                                  ></SplitNumber>
                                </span>
                                <span className="fs-085 fw-bold ms-1 d-inline-block">
                                  تومان
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    ))}
                  </Col>
                  <Col md="4" xl="3">
                    <Card
                      className="position-sticky mb-3"
                      style={{ top: "70px" }}
                    >
                      <Card.Body>
                        <div className="fw-bold px-3 pb-2 text-center border-bottom mb-3">
                          خلاصه سبد خرید
                        </div>
                        <div>
                          {basket.originalPrice !== basket.price && (
                            <div class="d-flex align-items-center">
                              <div
                                class="col-5 text-dark rounded text-center fs-075 mb-1 col"
                                style={{
                                  backgroundColor: "rgb(189, 190, 192)",
                                  paddingTop: "9px",
                                  paddingBottom: "10px",
                                }}
                              >
                                قیمت
                              </div>
                              <div
                                class="col-7 text-dark rounded  text-center py-2 ms-1 mb-1 fs-085 col"
                                style={{
                                  backgroundColor: "rgb(233, 236, 239)",
                                }}
                              >
                                <span className="text-decoration-line-throught-rotate border-secondary text-black-06">
                                  <SplitNumber number={basket?.originalPrice} />
                                </span>
                                <span className="fs-075 ms-1">تومان</span>
                              </div>
                            </div>
                          )}
                          {basket.salePrice !== basket.originalPrice && (
                            <div class="d-flex align-items-center">
                              <div
                                class="col-5 rounded text-dark  fs-075 text-center text-center  mb-1 col"
                                style={{
                                  backgroundColor: "rgb(255, 227, 143)",
                                  paddingTop: "10px",
                                  paddingBottom: "10px",
                                }}
                              >
                                تخفیف
                              </div>
                              <div
                                class="col-7 rounded text-dark text-center py-2 ms-1 mb-1 fs-085 col"
                                style={{
                                  backgroundColor: "rgb(255, 247, 224)",
                                }}
                              >
                                <SplitNumber
                                  number={
                                    basket?.originalPrice - basket?.salePrice
                                  }
                                />
                                <span className="fs-075 ms-1">تومان</span>
                              </div>
                            </div>
                          )}
                          {!_.isEmpty(ctx.basketInfo.promoCode) && (
                            <div class="d-flex align-items-center">
                              <div
                                class="col-5 rounded text-dark  fs-075 text-center text-center  mb-1 col"
                                style={{
                                  backgroundColor: "#ffc107",
                                  paddingTop: "9px",
                                  paddingBottom: "10px",
                                }}
                              >
                                تخفیف ویژه
                              </div>

                              <div
                                class="col-7 rounded text-dark text-center py-2 ms-1 mb-1 fs-085 col"
                                style={{
                                  backgroundColor: "#ffedb8",
                                }}
                              >
                                <SplitNumber
                                  number={
                                    ctx.basketInfo.salePrice -
                                    ctx.basketInfo.price
                                  }
                                />
                                <span className="fs-075 ms-1">تومان</span>
                              </div>
                            </div>
                          )}
                          <div class="d-flex align-items-center fs-normal">
                            <div
                              class="fw-bold rounded  text-white col-5  fs-075 text-center   col"
                              style={{
                                backgroundColor: "rgb(12, 164, 115)",
                                paddingTop: "9px",
                                paddingBottom: "10px",
                              }}
                            >
                              قیمت نهایی
                            </div>
                            <div
                              class="fw-bold rounded text-dark text-center col-7 py-2 ms-1  col"
                              style={{
                                backgroundColor: "rgb(193, 231, 219)",
                              }}
                            >
                              <span className="fs-085">
                                <SplitNumber number={basket?.price} />
                              </span>
                              <span className="fs-075 ms-1">تومان</span>
                            </div>
                          </div>
                        </div>
                        <form
                          className="mt-3"
                          id="form"
                          onSubmit={handleSubmit(onSubmitPromoCode)}
                        >
                          {specialDiscount && promoCodeIsSuccess && (
                            <div>
                              {/* <Form.Label className='large mx-2 my-2'>کد تخفیف</Form.Label> */}
                              {/* <hr className="p-0 my-0" /> */}
                              {/* <hr className="p-0 py-0 my-0" /> */}

                              {/* <FactorListItem
                FactorItemTitle="تخفیف ویژه"
                FactorItemCount={ctx.basketInfo.salePrice - ctx.basketInfo.price + " تومان"}
                bgcolor1="#ffc107"
                bgcolor2="#ffedb8"
               
                styleNameClass1="col-5 rounded text-dark mb-1  text-center "
                styleNameClass2="col-7 rounded text-dark text-center mb-1 py-2 mr-1 "
                isLine={false}
              />
           
              <FactorListItem
                FactorItemTitle="قیمت نهایی"
                FactorItemCount={ctx.basketInfo.price + " تومان"}
                bgcolor1="#0ca473"
                bgcolor2="#c1e7db"
                styleNameClass1="font-weight-bold rounded  text-white col-5  text-center  "
                styleNameClass2="font-weight-bold rounded text-dark text-center col-7 py-2 mr-1 "
                isLine={false}
              /> */}
                            </div>
                          )}

                          <div className="d-flex">
                            <Controller
                              control={control}
                              {...register("promoCode")}
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <Form.Control
                                  autoFocus={false}
                                  placeholder="کدتخفیف"
                                  name="promoCode"
                                  className="text-center text-dark rounded-end-0 font-latin"
                                  style={
                                    errors.promoCode
                                      ? {
                                          letterSpacing: "0px",
                                          borderColor: "red",
                                          height: "37px",
                                        }
                                      : value
                                      ? {
                                          letterSpacing: "5px",
                                          height: "37px",
                                        }
                                      : { height: "37px" }
                                  }
                                  maxLength="5"
                                  autoComplete="off"
                                  value={value || ""}
                                  onChange={onChange}
                                />
                              )}
                            />
                            <div className="d-flex align-items-center">
                              {/* <button
                        disabled
                        type="submit"
                        className="btn btn-primary mt-2 px-4"
                      >
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="state"
                          aria-hidden="true"
                        ></span>
                        ارسال کد
                      </button> */}
                              <Button
                                type="submit"
                                variant="warning"
                                className="text-center text-white fs-085 border-0 px-1"
                                style={{
                                  width: "83px",
                                  height: "37px",
                                  borderTopRightRadius: "0px",
                                  borderBottomRightRadius: "0px",
                                  backgroundColor: "#ff6400",
                                }}
                                autoComplete="off"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? (
                                  <>
                                    اعمال کد
                                    <span
                                      className="spinner-border spinner-border-sm ms-1"
                                      role="state"
                                      aria-hidden="true"
                                    ></span>
                                  </>
                                ) : (
                                  "اعمال کد"
                                )}
                              </Button>
                            </div>
                          </div>
                          {promoCodeIsSuccess ? (
                            <div className=" text-success font-weight-bold mt-2 mb-2">
                              {" "}
                              کد تخفیف با موفقیت اعمال گردید
                            </div>
                          ) : promoCodeIsSuccess == undefined ? (
                            ""
                          ) : (
                            <div>
                              <div className=" text-danger  mt-2 mb-2">
                                {" "}
                                کد تخفیف نامعتبر{" "}
                              </div>
                              {/* <ToastContainer
                          position="bottom-center"
                          autoClose={5000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={true}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                        /> */}
                            </div>
                          )}
                        </form>
                        <div className="pt-3">
                          {/* <button className="btn btn-primary w-100">
                        ادامه فرایند خرید
                      </button> */}
                          <Link className="btn btn-danger w-100" to="/payment">
                            ادامه فرآیند خرید
                          </Link>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </>
              )}
            </Row>
          </Container>
        </Container>
      )}
    </>
  );
}

export default BasketContent;
